import { FileExcelOutlined } from "@ant-design/icons";
import { Button, Skeleton } from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { images } from "../assets";
import { priceFormat } from "../utils";
import { convertToVnd } from "../utils/function";
import SImage from "./SImage";

export default function ProductSellingItem({ data = {} }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        navigate(
          `/product-details?drugId=${data.drug_id}`
        );
      }}
      className="sm:w-[347px] m-1 w-[200px] my-4 bg-white rounded-[16px] shadow hover:shadow-lg  mr-[24px]"
    >
      <div className="p-[13px] flex flex-row">
        {/* <div> */}
        <div className="sm:w-[162px] sm:h-[146px] w-[80px] h-[80px] flex items-center justify-center rounded-[12px] bg-[#E7EBEE]">
          <SImage src={data.image} alt="" className="block object-cover w-full h-full" />

        </div>
        {/* </div> */}
        {data.drug_name ? (
          <div className="flex flex-1 flex-col ml-2 text-left sm:gap-y-1">
            <p className="sm:text-sm text-[10px] font-bold text-main-blue text-two-lines">
              {data.drug_name}
            </p>

            <Link
              to={`/category?cateId=${data.category_id}`}
              onClick={(e) => e.stopPropagation()}
              className="sm:text-sm text-[8px] font-bold text-two-lines"
            >
              {data.category_name}
            </Link>

            <p className="sm:text-xs text-[8px] text-two-lines">Sản xuất: {data.company}</p>
            <div className="flex items-center justify-between">
              <h5 className="font-bold sm:text-[18px] text-xs  text-[#2297D4]">
                {priceFormat(data?.units.out_price)}
              </h5>
              {data?.units.out_price_org ? (
                <span className="price-old sm:text-[14px] text-[8px]">{priceFormat(1000)}</span>
              ) : null}
            </div>
          </div>
        ) : (
          <Skeleton className="ml-2" active />
        )}
      </div>
    </button>
  );
}
